var render, staticRenderFns
import script from "./dealers_record_flow.vue?vue&type=script&lang=js"
export * from "./dealers_record_flow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed8802f')) {
      api.createRecord('1ed8802f', component.options)
    } else {
      api.reload('1ed8802f', component.options)
    }
    
  }
}
component.options.__file = "found/views/cps/views/execute/dealers_record_flow/dealers_record_flow.vue"
export default component.exports